import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id BF72875E-F657-4469-B7B6-CC8116EC20D1
 * name knob
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/knob.svg
 * tags
 * - Audio 
 */
export const KnobIcon = createSvgIcon(<><path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M13 10H11V4.1C11.3 4 11.7 4 12 4S12.7 4 13 4.1V10Z" /></>, 'KnobIcon');
export default KnobIcon